module.exports = __webpack_public_path__ + "img/A1.68c0e91c.png";